import { createBrowserRouter } from 'react-router-dom';

import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import RootRedirect from './RootRedirect';

const router = createBrowserRouter(
  [{ path: '/', element: <RootRedirect /> }, AuthenticationRoutes, LoginRoutes, MainRoutes],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
